/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomCheckBoxV2.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */


import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

function CustomCheckBoxV2({ value, onChange, label, error, disabled, noPaddingRequired }) {
  return (
    <FormControlLabel
      sx={{
        ...(noPaddingRequired && { m: 0 }),
      }}
      control={
        <Checkbox
          size="small"
          checked={value}
          onChange={onChange}
          disabled={disabled}
          sx={{
            ...(noPaddingRequired && { p: 0 }),
            color: "black",
            "&.Mui-checked": {
              color: "#26890D",
            },
            "& .MuiSvgIcon-root": {
              fontWeight: "bold",
              width: 18,
              height: 18,
              overflow: "hidden",
              transition: "background-color 0.2s, color 0.2s",
            },
            "&:hover .MuiSvgIcon-root": {
              backgroundColor: "#D6D6D6",
              boxShadow: "none",
            },
            "&.Mui-checked:hover .MuiSvgIcon-root": {
              color: error ? "#941C13" : "#6F9A65",
              backgroundColor: "transparent", // keep background inside border clean
            },
            ...(error && {
              "& .MuiSvgIcon-root": {
                color: "red",
              },
              "&:hover .MuiSvgIcon-root": {
                color: "darkred",
              },
            }),
            "&.Mui-disabled": {
              color: "grey",
              "& .MuiSvgIcon-root": {
                color: "grey",
              },
            },
          }}
        />
      }
      label={label}
      disabled={disabled}
    />
  );
}

CustomCheckBoxV2.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.node,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  noPaddingRequired: PropTypes.bool,
};

CustomCheckBoxV2.defaultProps = {
  value: false,
  onChange: () => {},
  label: "",
  error: false,
  disabled: false,
  noPaddingRequired: false,
};

export default CustomCheckBoxV2;
